import { TopicWithConfig } from 'widgets/myPortfolioCapsules/topics/Topic';
import { TopicType } from 'widgets/myPortfolioCapsules/topics/TopicType';
import React from 'react';
import { PortfolioItem } from 'portfolio/PortfolioItem';
import {
    MyPortfolioCapsulesDataStateAggregation,
    MyPortfolioCapsulesSymbolDataState,
} from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesDataState';
import { MyPortfolioCapsulesDataItem } from 'widgets/myPortfolioCapsules/store/data/MyPortfolioCapsulesData';
import isNil from 'lodash/isNil';
import {
    defaultMoversTopicConfig,
    MoversTopicConfig,
} from 'widgets/myPortfolioCapsules/topics/movers/moversTopicConfig';
import { MoversTopicToolbar } from './MoversTopicToolbar';
import { WellKnownFeatureToggleKeys } from 'app/store/featureToggles/FeatureTogglesState';

export const moversTopic: TopicWithConfig<MoversTopicConfig> = {
    type: TopicType.Movers,
    description: 'Price Movement',
    requiredPortfolioColumns: ['movement'],
    accumulatedColumns: [],
    weights: [],
    calculateDerivedValues,
    getSymbolValues,
    help: (
        <div>
            This topic ranks symbols in your portfolio on the Absolute % Change
            from PNC (Previous Night&apos;s Close) using the symbol&apos;s last
            price. You can choose to exclude positive price movements or
            negative price movements. You can sort by ascending or descending
            and configure the number of symbols you would like to display.
        </div>
    ),
    getInitialTopicConfig: () => defaultMoversTopicConfig,
    toolbarItems: <MoversTopicToolbar />,
    featureToggle: WellKnownFeatureToggleKeys.LastPriceEnabled,
    deriveShouldExcludeZeros: () => false,
};

export function calculateDerivedValues(
    item: PortfolioItem,
    symbolDataState: MyPortfolioCapsulesSymbolDataState
) {
    const { movement } = item;
    if (!isNil(movement) && movement !== 0) {
        symbolDataState.derived.movement = movement;
    }
}

/*
 * Given aggregated data, calculates the values per symbol
 */
function getSymbolValues(
    aggregatedData: MyPortfolioCapsulesDataStateAggregation,
    config: MoversTopicConfig
): MyPortfolioCapsulesDataItem[] {
    return Object.keys(aggregatedData.bySymbol)
        .map((symbol) => ({
            symbol,
            symbolData: aggregatedData.bySymbol[symbol],
        }))
        .filter((data) => {
            return filterSymbol(data, config);
        })
        .map((data) => {
            const { symbol, symbolData } = data;

            const value = Math.abs(symbolData.derived.movement!);

            return {
                symbol,
                value,
                qty: symbolData.accumulated.qty,
                qtyTraded: symbolData.accumulated.qtyTraded,
                qtyRemaining: symbolData.accumulated.qtyRemaining,
            };
        });
}

function filterSymbol(
    data: { symbol: string; symbolData: MyPortfolioCapsulesSymbolDataState },
    config: MoversTopicConfig
) {
    if (data.symbolData.derived.movement === undefined) {
        return false;
    }

    const { includeNegative, includePositive } = config;

    if (!includePositive && data.symbolData.derived.movement > 0) {
        return false;
    }

    if (!includeNegative && data.symbolData.derived.movement < 0) {
        return false;
    }

    return true;
}
